import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import LicenceForm from '../../forms/Licence';
import LicenceServiceList from '../../modules/LicenceServiceList';
import AlertBox from '../../modules/AlertBox';
import AlertMessage from '../../modules/AlertMessage';

import * as licenceActions from '../../../actions/licences';

import styles from './styles.scss';

class AdminEditLicence extends React.Component {

    componentDidMount() {

        this.props.resetLicence();
        this.props.refreshLicence(this._getLicenceId());
    }

    _getLicenceId() {

        return this.props.match.params.id;
    }

    _updateLicence(params) {

        return this.props.updateLicence({id: this.props.licence.id, ...params})
            .then((updatedLicence) => {
                this.props.history.push(`/admin/edit-licence/${updatedLicence.id}`);
            });
    }

    render() {

        const { licence } = this.props;

        return (
            <Page>
                <PageMeta title="Edit Licence" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    <PageSection>

                        <Link className={styles['back-to-licences']} to="/admin/licences">
                            &larr; Back to service licences
                        </Link>

                        <AlertMessage>
                            {licence && licence.used_by_service_count > 0 &&
                                <AlertBox className={styles['related-services']} theme="warning">
                                    <p>
                                        Updating this licence will affect the following services:
                                    </p>

                                    <LicenceServiceList serviceLicences={licence.service_licences} />
                                </AlertBox>
                            }
                        </AlertMessage>

                        <LicenceForm
                            initialValues={licence}
                            enableReinitialize={true}
                            onSubmit={this._updateLicence.bind(this)}
                        />

                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        licence: state.licences.licence
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetLicence() {
            dispatch(licenceActions.licenceRefreshed(null));
        },
        refreshLicence(id) {
            dispatch(licenceActions.refreshLicence(id));
        },
        updateLicence(params) {
            return dispatch(licenceActions.updateLicence(params));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminEditLicence);